module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/is-pure.js
// module id = VFe2
// module chunks = 0